import * as React from "react";
import * as _ from "lodash";
import {getText} from "../utils/langTexts";
import {connect} from "react-redux";
import {ApplicationState} from "../store";
import * as RatesFetcher from "../store/RatesFetcher";
import {colors} from "../styles/colors";
import * as Api from '../api/api';
import * as Colors from "../styles/colors";
import Button from "./Button";
import {Paper, Popper} from "@material-ui/core";
import {Lock } from "@material-ui/icons";

type MfaPopupProps = MfaPopupOwnProps
    & RatesFetcher.RatesFetcherState
    & typeof RatesFetcher.actionCreators;

interface MfaPopupOwnProps {
    carrierRatesPlatforms: {[id: number]: Api.CarrierRatesPlatformModel }
    carriers: {[id: number]: Api.CarrierModel }
    accountEmail : string;
    style?: React.CSSProperties;
}

const inputStyle = { minWidth: 200, height: 25, borderRadius: 5, borderColor: Colors.baseColors.darkGray, borderWidth: 0.5, } as React.CSSProperties;

class MfaPopup extends React.Component<MfaPopupProps, {}> {
    constructor(props: MfaPopupProps) {
        super(props);
    }

    public render() {
        console.log(_.keys(this.props.mfaStates));
        console.log(this.props.mfaStates);

        let keys = _.keys(this.props.mfaStates);
        let showMfa = ["ZIM2", "ZIM3"];

        if (!showMfa.some(x =>   keys.some(k=> x === k && !this.props.mfaStates[k].isSent))) {
            return null;
        }

        return (
            <Paper about={"Mfa popup"}
                   style={{border: `1px solid ${Colors.baseColors.darkGray}`, borderRadius: 12, zIndex: 999}}>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "stretch",
                    padding: "10px 15px"
                }}>
                    {_.map(_.keys(this.props.mfaStates), platformCode => {
                        let platform = _.values(this.props.carrierRatesPlatforms).find(x => x.code === platformCode);
                        console.log(platform);
                        let carrierCode = this.props.carriers[platform?.carrierId]?.code;
                        console.log(carrierCode);

                        if (!showMfa.some(x => x === platformCode)) {
                            return null;
                        }

                        if (!carrierCode)
                            return null;
                        
                        if(this.props.mfaStates[platformCode].isSent)
                            return null;

                        return <div key={platformCode}>
                            <div style={{color: colors.main1.color}}>
                                <div style={{ paddingBottom: "5px" }}>
                                    <Lock style={{ color: colors.main2.color, position: "relative", top: "0.15em" }} /> To view {carrierCode} rates, please verify your account.
                                </div>
                                <div style={{ lineHeight: "20px" }}>
                                    <div>A verification code has been sent to:</div>
                                    <div style={{color: "#4169E1"}}>{this.props.mfaStates[platformCode].email || this.props.accountEmail}</div>
                                    <div>Please check this email and enter the code below:</div>
                                </div>
                            </div>
                            {showMfa.some(x => x === platform.code)
                                && <div style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    columnGap: 5,
                                    color: colors.main1.color,
                                    paddingTop: 5
                                }}>
                                    <input
                                        style={inputStyle}
                                        value={this.props.mfaStates[platformCode].value}
                                        onChange={(e) => this.props.updateMfaValue(platformCode, e.target.value)}/>
                                    <Button
                                        style={{
                                            minWidth: 100,
                                            height: 30,
                                        }}
                                        onClick={(e) => {
                                            this.props.requestProvideMfa(platformCode, this.props.mfaStates[platformCode].value, new Date().getTime());
                                            e.preventDefault();
                                        }}
                                        disabled={this.props.mfaStates[platformCode].isLoading}>
                                        {getText("OcqMfaSend")}
                                    </Button>
                                </div>}
                        </div>
                    })}
                </div>
            </Paper>
        );
    }
}

export default connect((state: ApplicationState) => ({
    ...state.ratesFetcher,
    carrierRatesPlatforms: state.seed.carrierRatesPlatforms,
    carriers: state.seed.carriers,
    accountEmail: state.account.currentUser?.clientModel?.account?.email
} as MfaPopupProps), { ...RatesFetcher.actionCreators })(MfaPopup) as any;